export default "__VITE_ASSET__Dn$rl4Se__"